import { mapState } from "vuex";

export default {
  computed: {
    ...mapState("partners", {
      partners: (state) => {
        return state.partners;
      },
    }),
    ...mapState("settings", {
      theme: (state) => state.theme,
    }),
  },
  methods: {
    pushRouteSelf(sTagName) {
      let href = this.partners[this.$i18n.locale].filter(
        (item) => item.tag === `${sTagName}${this.theme}`
      )[0].url;
      window.open(href, "_self");
    },
    pushRoute(sTagName) {
		let href = this.partners[this.$i18n.locale].filter(
			(item) => item.tag === sTagName
		  )[0].url;
      window.open(href, "_self");
    },
  },
};
